import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import styles from './styles.scss';

export default class Textarea extends React.Component {
  static propTypes = {
    name: PropTypes.string.isRequired,
    value: PropTypes.string,
    placeholder: PropTypes.string,
    label: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    errorMessage: PropTypes.string,
    maxLength: PropTypes.number,
  };

  state = {
    value: this.props.value || '',
  };

  componentDidUpdate(prevProps) {
    if (prevProps.value !== this.props.value) {
      this.setState({
        value: this.props.value,
      });
    }
  }

  onChange = (e) => {
    const { value } = e.target;
    this.props.onChange(value, this.props.name);
    this.setState({
      value,
    });
  };

  render() {
    const rootClassName = classNames(
      styles.textarea,
      {
        [styles['invalid']]: this.props.errorMessage,
      },
      this.props.extStyle
    );

    return (
      <div className={rootClassName}>
        {this.props.label && (
          <div className={styles.label} aria-hidden="true">
            {this.props.label}
          </div>
        )}
        <textarea
          name={this.props.name}
          aria-label={
            this.props.label ? this.props.label.replace('*', ' Pflichtangabe') : undefined
          }
          placeholder={this.props.placeholder}
          value={this.state.value}
          onChange={this.onChange}
        />
        <div className={styles.error}>
          {this.props.errorMessage && (
            <div className={styles.errorMessage} role="alert" aria-live="assertive">
              {this.props.errorMessage}
            </div>
          )}
          {this.props.maxLength && (
            <div
              className={classNames(styles.charCount, {
                [styles.invalid]: this.state.value.length > this.props.maxLength,
              })}
            >
              {this.state.value.length}/{this.props.maxLength}
            </div>
          )}
        </div>
      </div>
    );
  }
}
